exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue[data-v-6644f768]{color:#335dc9;cursor:pointer;text-decoration:underline}.ql-table[data-v-6644f768]{width:100%}", ""]);

// exports
